<p-toast key="http-error" position="bottom-right" />

<div class="flex h-screen w-full overflow-hidden bg-gray-50">

  <app-sidebar
    [visible]="sidebarVisible()"
    class="flex-none z-20 shadow-lg"
  />

  <div class="flex flex-col flex-1 min-w-0 h-full relative">

    <app-topbar
      [sidebarVisible]="sidebarVisible()"
      (toggleSidebar)="onSidebarToggle()"
      class="flex-none z-10"
    />

    <main class="flex-1 overflow-y-auto p-6 bg-slate-50 relative">
      <router-outlet />
    </main>

  </div>
</div>
